"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const MicOffOutlined_1 = __importDefault(require("@material-ui/icons/MicOffOutlined"));
const VolumeIndicator_1 = __importDefault(require("../VolumeIndicator"));
const hooks_1 = require("../hooks");
const Clock_1 = __importDefault(require("./Clock"));
const styles_1 = __importDefault(require("./styles"));
const CallStatusBar = ({ elapsed, logo, remoteName, remotePartcipant, showMicrophoneIcon = false, style, }) => {
    const classes = styles_1.default();
    const [, audioTrack] = hooks_1.useParticipantTracks(remotePartcipant);
    const renderMicrophone = () => {
        if (!audioTrack) {
            return react_1.default.createElement(MicOffOutlined_1.default, { className: classes.disabledIcon });
        }
        return react_1.default.createElement(VolumeIndicator_1.default, { track: audioTrack, id: audioTrack.name });
    };
    return (react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "row", justify: "space-around", alignItems: "center", className: classes.statusBar, style: style, spacing: 1 },
        logo && (react_1.default.createElement(core_1.Grid, { item: true, className: classes.iconContainer }, logo)),
        remoteName && (react_1.default.createElement(core_1.Grid, { item: true, className: classes.iconContainer },
            react_1.default.createElement(core_1.Typography, { variant: "body1", color: "textSecondary" }, remoteName))),
        showMicrophoneIcon && (react_1.default.createElement(core_1.Grid, { item: true, className: classes.iconContainer }, renderMicrophone())),
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(Clock_1.default, { elapsed: elapsed }))));
};
exports.default = CallStatusBar;
